export function sleep(seconds) {
    var miliseconds = seconds * 1000;
    return new Promise(resolve => setTimeout(resolve, miliseconds));
}